// --- src/components/UI/Button.js ---
import React from 'react';
const Button = ({ children, variant = 'primary', onClick, icon: Icon, className='', style={}, disabled=false, ...rest }) => (
  <button className={`btn btn-${variant} ${className}`} onClick={onClick} style={style} disabled={disabled} {...rest}>
    {Icon && <Icon size={16} />}
    {children}
  </button>
);
export default Button;
